module.exports = __webpack_public_path__ + "img/poubelle.1f71238b.svg";